var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.012 2.145a1.719 1.719 0 00-1.851.306l-2.161 2V2.999c0-1.654-1.345-3-3-3H3c-1.654 0-3 1.346-3 3v8c0 1.655 1.346 3 3 3h9c1.655 0 3-1.345 3-3V9.548l2.16 1.999a1.723 1.723 0 001.851.307c.61-.266.989-.835.989-1.484V3.629c0-.649-.38-1.218-.988-1.484z",
    fill: "#04B7D6"
  })));
}

export default SvgVideoFilled;